/* eslint-disable no-underscore-dangle */
import { useState } from 'react'
import { ProductItemsFragment } from '../../graphql/ProductItems.gql'

// @todo: figure out why this code runs twice, for now use useState to only trigger once
export function useKlaviyoViewProductEvent(
  product: ProductItemsFragment | null | undefined,
  locale: string | undefined,
) {
  const [pushed, setPushed] = useState(false)
  if (!product || pushed) return
  const localeToKlaviyoStoreName = {
    nl: 'Nederlands',
    en: 'English',
    es: 'Español',
    de: 'Deutsch',
    fr: 'Français',
    it: 'Italiano',
  }

  globalThis._learnq = globalThis._learnq || []
  const item = {
    ProductName: product.name,
    ProductID: product.uid,
    SKU: product.sku,
    Categories: product.categories,
    ImageURL: product.media_gallery?.at(0),
    URL: product.url_key,
    Brand: product.merk,
    Price: product.price_range.minimum_price.final_price.value,
    StoreName: localeToKlaviyoStoreName[locale ?? 'NOT FOUND'],
  }
  globalThis._learnq.push(['track', 'Viewed Product', item])
  setPushed(true)
}
